import axios, { type AxiosInstance, type CreateAxiosDefaults } from 'axios';
import { requestInterceptor, requestErrorInterceptor } from './interceptors/request.interceptor';
import { responseInterceptor, responseErrorInterceptor } from './interceptors/response.interceptor';

export const createAxiosInstance = (config: CreateAxiosDefaults): AxiosInstance => {
  const instance = axios.create(config);

  instance.interceptors.request.use(requestInterceptor, requestErrorInterceptor);
  instance.interceptors.response.use(responseInterceptor, responseErrorInterceptor);

  return instance;
};
